var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlliedstarLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11.80837,
    height: 7.9977841,
    viewBox: "0 0 11.80837 7.9977841",
    fill: "none",
    id: "svg2",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3",
    transform: "translate(-0.10405978,-1.9279618)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0051d4",
    d: "M 10.91878,5.9006957 10.369289,5.7189086 Q 9.9162064,5.5884505 9.4673982,5.6675805 8.9886116,5.7296039 8.6137116,5.9841055 7.9956718,6.4032854 6.0376443,7.7634841 a 0.02999161,0.02994149 0 0 0 -0.012831,0.026716 q 0.00429,0.051327 0.014979,-0.013904 -0.00963,0.053466 -0.059986,0.027806 -0.00121,-0.037425 -0.041774,-0.065228 Q 4.6944526,6.8780545 3.4487322,6.0204434 3.0213465,5.726378 2.5136302,5.6611457 1.9930619,5.5862955 1.5110567,5.7670115 1.2796915,5.8942666 1.0911782,5.8996131 2.4108067,4.5672149 3.7282944,3.2540644 4.6141148,2.3707942 4.8476209,2.2349852 C 5.7612933,1.7045943 6.913831,1.8767563 7.6711167,2.6327786 Q 9.2895891,4.2506899 10.91878,5.9006799 Z",
    id: "path20-3",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.107022
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4-4-8",
    style: {
      fill: "#ffffff",
      fillOpacity: 0.496154,
      strokeWidth: 0.0387134
    },
    d: "M 8.4199589,9.490171 8.4026127,7.7428955 8.3852665,5.9956199 7.1967397,6.8882441 6.0082129,7.78087 7.2140859,8.6355213 Z M 7.5278196,7.7334302 A 2.1923045,2.1923044 0 0 0 9.7201249,9.9257356 2.1923045,2.1923044 0 0 0 11.91243,7.7334302 2.1923045,2.1923044 0 0 0 9.7201249,5.5411259 2.1923045,2.1923044 0 0 0 7.5278196,7.7334302 Z M 3.5965239,9.4901809 3.6138701,7.7429053 3.6312163,5.9956298 4.8197431,6.888254 6.0082699,7.7808799 4.8023969,8.6355312 Z M 4.4886632,7.7334417 A 2.1923045,2.1923044 0 0 1 2.2963651,9.9257455 2.1923045,2.1923044 0 0 1 0.10405978,7.7334417 2.1923045,2.1923044 0 0 1 2.2963651,5.5411366 2.1923045,2.1923044 0 0 1 4.4886632,7.7334417 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlliedstarLogo);
export default __webpack_public_path__ + "static/media/alliedstar_logo.1a49adbdf65735704ee8766fba7f0b13.svg";
export { ForwardRef as ReactComponent };